export default __webpack_public_path__ + "static/media/equipment.b7a0c7d2.jpg";